import { Select } from '@approvalmax/ui/src/components';
import { ui } from 'modules/common';
import { memo } from 'react';

import { useSelectMonth } from './SelectMonth.hooks';
import { SelectMonthProps } from './SelectMonth.types';

export const SelectMonth = memo<SelectMonthProps>((props) => {
    const { month, onChange } = props;

    const { value, handleChange } = useSelectMonth(month, onChange);

    return (
        <Select
            size='small'
            itemIdKey='id'
            itemNameKey='text'
            qa='month'
            items={ui.allMonthReferences}
            value={value}
            onChange={handleChange}
            clearable={false}
        />
    );
});

SelectMonth.displayName = 'SelectMonth';
